import type {
  GetDomainsManagementRegistrarAccountsCountData,
  GetDomainsManagementRegistrarAccountsCountResponse,

  GetDomainsManagementRegistrarAccountsData,
  GetDomainsManagementRegistrarAccountsResponse,

  PostDomainsManagementRegistrarAccountsData,
  PostDomainsManagementRegistrarAccountsResponse,

  GetDomainsManagementRegistrarAccountsByIdData,
  GetDomainsManagementRegistrarAccountsByIdResponse,

  PutDomainsManagementRegistrarAccountsByIdData,
  PutDomainsManagementRegistrarAccountsByIdResponse,

  DeleteDomainsManagementRegistrarAccountsByIdData,
  DeleteDomainsManagementRegistrarAccountsByIdResponse
} from "@/types/openapi-ts";
import type { AxiosInstance } from "axios";


export function getDomainRegistrarAccountsApiModule(affiliatesApi: AxiosInstance) {
  return {
    /**
     * Get domain registrar accounts count
     *
     * @param {Object} params
     * @param {String} params.search
     *
     * @return {Promise<Object>} api response
     */
    getDomainRegistrarAccountsCount(params: GetDomainsManagementRegistrarAccountsCountData['query']) {
      return affiliatesApi.get<GetDomainsManagementRegistrarAccountsCountResponse>(
        '/domains-management/registrar-accounts/count',
        { params }
      );
    },

    /**
     * Get domain registrar accounts
     *
     * @param {Object} params
     * @param {String} params.sort_column
     * @param {String} params.sort_dir
     * @param {String} params.search
     * @param {Number} params.limit
     * @param {Number} params.offset
     *
     * @return {Promise<Object>} api response
     */
    getDomainRegistrarAccounts(params: GetDomainsManagementRegistrarAccountsData['query']) {
      return affiliatesApi.get<GetDomainsManagementRegistrarAccountsResponse>(
        '/domains-management/registrar-accounts',
        { params }
      );
    },

    /**
     * Create domain registrar account
     *
     * @param {Object} data
     * @param {String} data.name
     * @param {String} data.domain_registrar_id
     * @param {Boolean} data.auto_ns_management
     * @param {Object} data.auth_data
     *
     * @return {Promise<Object>} api response
     */
    createDomainRegistrarAccount(data: PostDomainsManagementRegistrarAccountsData['body']) {
      return affiliatesApi.post<PostDomainsManagementRegistrarAccountsResponse>(
        '/domains-management/registrar-accounts',
        data
      );
    },

    /**
     * Get domain registrar account by id
     *
     * @param {String} id
     *
     * @return {Promise<Object>} api response
     */
    getDomainRegistrarAccountById(id: string) {
      return affiliatesApi.get<GetDomainsManagementRegistrarAccountsByIdResponse>(
        `/domains-management/registrar-accounts/${id}`
      );
    },

    /**
     * Update domain registrar account
     *
     * @param {String} id
     * @param {Object} data
     * @param {String} data.name
     * @param {Boolean} data.auto_ns_management
     * @param {Object} data.auth_data
     *
     * @return {Promise<Object>} api response
     */
    updateDomainRegistrarAccount(id: string, data: PutDomainsManagementRegistrarAccountsByIdData['body']) {
      return affiliatesApi.put<PutDomainsManagementRegistrarAccountsByIdResponse>(
        `/domains-management/registrar-accounts/${id}`,
        data
      );
    },

    /**
     * Delete domain registrar account by id
     *
     * @param {String} id
     *
     * @return {Promise<Object>} api response
     */
    deleteDomainRegistrarAccount(id: string) {
      return affiliatesApi.delete<DeleteDomainsManagementRegistrarAccountsByIdResponse>(
        `/domains-management/registrar-accounts/${id}`
      );
    },
  }
}
